import _ from 'lodash'
import Api from 'redux-apis'


import { commonChildApiProps } from './commonUtils'

export default class Jobs extends Api {
  constructor (saltApi) {
    super({})

    Object.defineProperties(this, {
      ...commonChildApiProps(saltApi, this),
    })
    // Action handlers (reducers)
    this.setHandler('SET_JOBS', (state, action) => {
      return _.merge(state||{}, action.payload || {})
    })
  }

  getJobs(jid) {
    return this
      .aio.get(`/jobs/${ jid ? jid : ''}`)
      .then(res => {
        if (jid && jid !== '')
          return {
            [jid]: _.extend(
              res.data.info[0],
              {Return: res.data.info.Return})
          }
        return res.data.return[0]
      })
      .then(res => {
        this.setStateChanges('SET_JOBS', res)
        if (jid)
          return res[jid]
        return res
      })
  }
}



// WEBPACK FOOTER //
// ./src/saltapi/Jobs.js